import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomUndoAiMappingRunAreaMutation } from "generated/graphql";

export const useUndoAiMappingRunArea = () => {
  const [mutation, { data, loading, error }] = useCustomUndoAiMappingRunAreaMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "undoAiMappingRunArea" },
    { hideMessage: true }
  );
};
